import { getConfigValue } from "./config";

const BASE_API_URL = getConfigValue('BASE_API_URL');
const NODE_ENV = getConfigValue("NODE_ENV")


export const getAnyFileUrlByToken = ({ token='', ext = 'jpg', action = 'view', }): string =>
    process.env.VUE_APP_BASE_API_URL + `/media/full/${token!}.${ext}?action=${action}`;

export const getFileUrlById = ({ fileId = '', size = 'full', ext = 'jpg' }) => {
    if (NODE_ENV === "dev" || NODE_ENV === "local") {
        return `https://api-contentfactory.tawa.digital/file/thumb/${size}/${fileId}.${ext}`
    }
    return `https://api-contentfactory.tawa.digital/file/thumb/${size}/${fileId}.${ext}`
    //return `${BASE_API_URL}/file/thumb/${size}/${fileId}.${ext}`
}

export const getFileUrlByToken = ({ token = '', size = 'full', ext = 'jpg' }): string => {
    /* if (NODE_ENV === "dev" || NODE_ENV === "local") {
        return `https://api-contentfactory.tawa.digital/v2/media/${size}/${token}.${ext}`
    } */

    return `https://api-contentfactory.tawa.digital/v2/media/${size}/${token}.${ext}`
    //return `${BASE_API_URL.replace('/v2', '')}/v2/media/${size}/${token}.${ext}`
}

export const isMediaQueryMobile = () => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    return (mediaQuery.matches);
}

export const isMediaQueryDesktop = () => {
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    return (mediaQuery.matches);
}

export const countries = [
    {
        "label": "Afghanistan",
        "value": "AF",
        "icon": "af",
        "iso_3": "AFG",
        "prefix": 93,
        "region": "Asia",
        "sub_region": "Southern Asia"
    },
    {
        "label": "Åland Islands",
        "value": "AX",
        "icon": "ax",
        "iso_3": "ALA",
        "prefix": 358,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Albania",
        "value": "AL",
        "icon": "al",
        "iso_3": "ALB",
        "prefix": 355,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Algeria",
        "value": "DZ",
        "icon": "dz",
        "iso_3": "DZA",
        "prefix": 213,
        "region": "Africa",
        "sub_region": "Northern Africa"
    },
    {
        "label": "American Samoa",
        "value": "AS",
        "icon": "as",
        "iso_3": "ASM",
        "prefix": 1684,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    {
        "label": "Andorra",
        "value": "AD",
        "icon": "ad",
        "iso_3": "AND",
        "prefix": 376,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Angola",
        "value": "AO",
        "icon": "ao",
        "iso_3": "AGO",
        "prefix": 244,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Anguilla",
        "value": "AI",
        "icon": "ai",
        "iso_3": "AIA",
        "prefix": 1264,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    // {
    //   "label": "Antarctica",
    //   "value": "AQ",
    //   "icon": "aq",
    //   "iso_3": "ATA",
    //   "prefix": 672,
    //   "region": "",
    //   "sub_region": ""
    // },
    {
        "label": "Antigua and Barbuda",
        "value": "AG",
        "icon": "ag",
        "iso_3": "ATG",
        "prefix": 1268,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Argentina",
        "value": "AR",
        "icon": "ar",
        "iso_3": "ARG",
        "prefix": 54,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Armenia",
        "value": "AM",
        "icon": "am",
        "iso_3": "ARM",
        "prefix": 374,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Aruba",
        "value": "AW",
        "icon": "aw",
        "iso_3": "ABW",
        "prefix": 297,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Australia",
        "value": "AU",
        "icon": "au",
        "iso_3": "AUS",
        "prefix": 61,
        "region": "Oceania",
        "sub_region": "Australia and New Zealand"
    },
    {
        "label": "Austria",
        "value": "AT",
        "icon": "at",
        "iso_3": "AUT",
        "prefix": 43,
        "region": "Europe",
        "sub_region": "Western Europe"
    },
    {
        "label": "Azerbaijan",
        "value": "AZ",
        "icon": "az",
        "iso_3": "AZE",
        "prefix": 994,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Bahamas",
        "value": "BS",
        "icon": "bs",
        "iso_3": "BHS",
        "prefix": 1242,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Bahrain",
        "value": "BH",
        "icon": "bh",
        "iso_3": "BHR",
        "prefix": 973,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Bangladesh",
        "value": "BD",
        "icon": "bd",
        "iso_3": "BGD",
        "prefix": 880,
        "region": "Asia",
        "sub_region": "Southern Asia"
    },
    {
        "label": "Barbados",
        "value": "BB",
        "icon": "bb",
        "iso_3": "BRB",
        "prefix": 1246,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Belarus",
        "value": "BY",
        "icon": "by",
        "iso_3": "BLR",
        "prefix": 375,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "Belgium",
        "value": "BE",
        "icon": "be",
        "iso_3": "BEL",
        "prefix": 32,
        "region": "Europe",
        "sub_region": "Western Europe"
    },
    {
        "label": "Belize",
        "value": "BZ",
        "icon": "bz",
        "iso_3": "BLZ",
        "prefix": 501,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Benin",
        "value": "BJ",
        "icon": "bj",
        "iso_3": "BEN",
        "prefix": 229,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Bermuda",
        "value": "BM",
        "icon": "bm",
        "iso_3": "BMU",
        "prefix": 1441,
        "region": "Americas",
        "sub_region": "Northern America"
    },
    {
        "label": "Bhutan",
        "value": "BT",
        "icon": "bt",
        "iso_3": "BTN",
        "prefix": 975,
        "region": "Asia",
        "sub_region": "Southern Asia"
    },
    {
        "label": "Bolivia, Plurinational State of",
        "value": "BO",
        "icon": "bo",
        "iso_3": "BOL",
        "prefix": 591,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    // {
    //   "label": "Bonaire, Sint Eustatius and Saba",
    //   "value": "BQ",
    //   "icon": "bq",
    //   "iso_3": "BES",
    //   "prefix": 599,
    //   "region": "Americas",
    //   "sub_region": "Latin America and the Caribbean"
    // },
    {
        "label": "Bosnia and Herzegovina",
        "value": "BA",
        "icon": "ba",
        "iso_3": "BIH",
        "prefix": 387,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Botswana",
        "value": "BW",
        "icon": "bw",
        "iso_3": "BWA",
        "prefix": 267,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Bouvet Island",
        "value": "BV",
        "icon": "bv",
        "iso_3": "BVT",
        "prefix": 47,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Brazil",
        "value": "BR",
        "icon": "br",
        "iso_3": "BRA",
        "prefix": 55,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "British Indian Ocean Territory",
        "value": "IO",
        "icon": "io",
        "iso_3": "IOT",
        "prefix": 1284,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Brunei Darussalam",
        "value": "BN",
        "icon": "bn",
        "iso_3": "BRN",
        "prefix": 673,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Bulgaria",
        "value": "BG",
        "icon": "bg",
        "iso_3": "BGR",
        "prefix": 359,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "Burkina Faso",
        "value": "BF",
        "icon": "bf",
        "iso_3": "BFA",
        "prefix": 226,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Burundi",
        "value": "BI",
        "icon": "bi",
        "iso_3": "BDI",
        "prefix": 257,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Cabo Verde",
        "value": "CV",
        "icon": "cv",
        "iso_3": "CPV",
        "prefix": 238,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Cambodia",
        "value": "KH",
        "icon": "kh",
        "iso_3": "KHM",
        "prefix": 855,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Cameroon",
        "value": "CM",
        "icon": "cm",
        "iso_3": "CMR",
        "prefix": 237,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Canada",
        "value": "CA",
        "icon": "ca",
        "iso_3": "CAN",
        "prefix": 1,
        "region": "Americas",
        "sub_region": "Northern America"
    },
    {
        "label": "Cayman Islands",
        "value": "KY",
        "icon": "ky",
        "iso_3": "CYM",
        "prefix": 1345,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Central African Republic",
        "value": "CF",
        "icon": "cf",
        "iso_3": "CAF",
        "prefix": 236,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Chad",
        "value": "TD",
        "icon": "td",
        "iso_3": "TCD",
        "prefix": 235,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Chile",
        "value": "CL",
        "icon": "cl",
        "iso_3": "CHL",
        "prefix": 56,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "China",
        "value": "CN",
        "icon": "cn",
        "iso_3": "CHN",
        "prefix": 86,
        "region": "Asia",
        "sub_region": "Eastern Asia"
    },
    {
        "label": "Christmas Island",
        "value": "CX",
        "icon": "cx",
        "iso_3": "CXR",
        "prefix": 61,
        "region": "Oceania",
        "sub_region": "Australia and New Zealand"
    },
    {
        "label": "Cocos (Keeling) Islands",
        "value": "CC",
        "icon": "cc",
        "iso_3": "CCK",
        "prefix": 61,
        "region": "Oceania",
        "sub_region": "Australia and New Zealand"
    },
    {
        "label": "Colombia",
        "value": "CO",
        "icon": "co",
        "iso_3": "COL",
        "prefix": 57,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Comoros",
        "value": "KM",
        "icon": "km",
        "iso_3": "COM",
        "prefix": 269,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Congo",
        "value": "CG",
        "icon": "cg",
        "iso_3": "COG",
        "prefix": 242,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Congo, Democratic Republic of the",
        "value": "CD",
        "icon": "cd",
        "iso_3": "COD",
        "prefix": 242,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Cook Islands",
        "value": "CK",
        "icon": "ck",
        "iso_3": "COK",
        "prefix": 682,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    {
        "label": "Costa Rica",
        "value": "CR",
        "icon": "cr",
        "iso_3": "CRI",
        "prefix": 506,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Côte d'Ivoire",
        "value": "CI",
        "icon": "ci",
        "iso_3": "CIV",
        "prefix": 225,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Croatia",
        "value": "HR",
        "icon": "hr",
        "iso_3": "HRV",
        "prefix": 385,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Cuba",
        "value": "CU",
        "icon": "cu",
        "iso_3": "CUB",
        "prefix": 53,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Curaçao",
        "value": "CW",
        "icon": "cw",
        "iso_3": "CUW",
        "prefix": 599,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Cyprus",
        "value": "CY",
        "icon": "cy",
        "iso_3": "CYP",
        "prefix": 357,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Czechia",
        "value": "CZ",
        "icon": "cz",
        "iso_3": "CZE",
        "prefix": 420,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "Denmark",
        "value": "DK",
        "icon": "dk",
        "iso_3": "DNK",
        "prefix": 45,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Djibouti",
        "value": "DJ",
        "icon": "dj",
        "iso_3": "DJI",
        "prefix": 253,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Dominica",
        "value": "DM",
        "icon": "dm",
        "iso_3": "DMA",
        "prefix": 1767,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Dominican Republic",
        "value": "DO",
        "icon": "do",
        "iso_3": "DOM",
        "prefix": 1809,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Ecuador",
        "value": "EC",
        "icon": "ec",
        "iso_3": "ECU",
        "prefix": 593,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Egypt",
        "value": "EG",
        "icon": "eg",
        "iso_3": "EGY",
        "prefix": 20,
        "region": "Africa",
        "sub_region": "Northern Africa"
    },
    {
        "label": "El Salvador",
        "value": "SV",
        "icon": "sv",
        "iso_3": "SLV",
        "prefix": 503,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Equatorial Guinea",
        "value": "GQ",
        "icon": "gq",
        "iso_3": "GNQ",
        "prefix": 240,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Eritrea",
        "value": "ER",
        "icon": "er",
        "iso_3": "ERI",
        "prefix": 291,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Estonia",
        "value": "EE",
        "icon": "ee",
        "iso_3": "EST",
        "prefix": 372,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Eswatini",
        "value": "SZ",
        "icon": "sz",
        "iso_3": "SWZ",
        "prefix": 268,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Ethiopia",
        "value": "ET",
        "icon": "et",
        "iso_3": "ETH",
        "prefix": 251,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Falkland Islands (Malvinas)",
        "value": "FK",
        "icon": "fk",
        "iso_3": "FLK",
        "prefix": 500,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Faroe Islands",
        "value": "FO",
        "icon": "fo",
        "iso_3": "FRO",
        "prefix": 298,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Fiji",
        "value": "FJ",
        "icon": "fj",
        "iso_3": "FJI",
        "prefix": 679,
        "region": "Oceania",
        "sub_region": "Melanesia"
    },
    {
        "label": "Finland",
        "value": "FI",
        "icon": "fi",
        "iso_3": "FIN",
        "prefix": 358,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "France",
        "value": "FR",
        "icon": "fr",
        "iso_3": "FRA",
        "prefix": 33,
        "region": "Europe",
        "sub_region": "Western Europe"
    },
    {
        "label": "French Guiana",
        "value": "GF",
        "icon": "gf",
        "iso_3": "GUF",
        "prefix": 594,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "French Polynesia",
        "value": "PF",
        "icon": "pf",
        "iso_3": "PYF",
        "prefix": 689,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    // {
    //   "label": "French Southern Territories",
    //   "value": "TF",
    //   "icon": "tf",
    //   "iso_3": "ATF",
    //   "prefix": 262,
    //   "region": "Africa",
    //   "sub_region": "Sub-Saharan Africa"
    // },
    {
        "label": "Gabon",
        "value": "GA",
        "icon": "ga",
        "iso_3": "GAB",
        "prefix": 241,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Gambia",
        "value": "GM",
        "icon": "gm",
        "iso_3": "GMB",
        "prefix": 220,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Georgia",
        "value": "GE",
        "icon": "ge",
        "iso_3": "GEO",
        "prefix": 995,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Germany",
        "value": "DE",
        "icon": "de",
        "iso_3": "DEU",
        "prefix": 49,
        "region": "Europe",
        "sub_region": "Western Europe"
    },
    {
        "label": "Ghana",
        "value": "GH",
        "icon": "gh",
        "iso_3": "GHA",
        "prefix": 233,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Gibraltar",
        "value": "GI",
        "icon": "gi",
        "iso_3": "GIB",
        "prefix": 350,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Greece",
        "value": "GR",
        "icon": "gr",
        "iso_3": "GRC",
        "prefix": 30,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Greenland",
        "value": "GL",
        "icon": "gl",
        "iso_3": "GRL",
        "prefix": 299,
        "region": "Americas",
        "sub_region": "Northern America"
    },
    {
        "label": "Grenada",
        "value": "GD",
        "icon": "gd",
        "iso_3": "GRD",
        "prefix": 1473,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Guadeloupe",
        "value": "GP",
        "icon": "gp",
        "iso_3": "GLP",
        "prefix": 590,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Guam",
        "value": "GU",
        "icon": "gu",
        "iso_3": "GUM",
        "prefix": 1671,
        "region": "Oceania",
        "sub_region": "Micronesia"
    },
    {
        "label": "Guatemala",
        "value": "GT",
        "icon": "gt",
        "iso_3": "GTM",
        "prefix": 502,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Guernsey",
        "value": "GG",
        "icon": "gg",
        "iso_3": "GGY",
        "prefix": 44,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Guinea",
        "value": "GN",
        "icon": "gn",
        "iso_3": "GIN",
        "prefix": 224,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Guinea-Bissau",
        "value": "GW",
        "icon": "gw",
        "iso_3": "GNB",
        "prefix": 245,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Guyana",
        "value": "GY",
        "icon": "gy",
        "iso_3": "GUY",
        "prefix": 592,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Haiti",
        "value": "HT",
        "icon": "ht",
        "iso_3": "HTI",
        "prefix": 509,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Heard Island and McDonald Islands",
        "value": "HM",
        "icon": "hm",
        "iso_3": "HMD",
        "prefix": 334,
        "region": "Oceania",
        "sub_region": "Australia and New Zealand"
    },
    {
        "label": "Holy See",
        "value": "VA",
        "icon": "va",
        "iso_3": "VAT",
        "prefix": 379,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Honduras",
        "value": "HN",
        "icon": "hn",
        "iso_3": "HND",
        "prefix": 504,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Hong Kong",
        "value": "HK",
        "icon": "hk",
        "iso_3": "HKG",
        "prefix": 852,
        "region": "Asia",
        "sub_region": "Eastern Asia"
    },
    {
        "label": "Hungary",
        "value": "HU",
        "icon": "hu",
        "iso_3": "HUN",
        "prefix": 36,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "Iceland",
        "value": "IS",
        "icon": "is",
        "iso_3": "ISL",
        "prefix": 354,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "India",
        "value": "IN",
        "icon": "in",
        "iso_3": "IND",
        "prefix": 91,
        "region": "Asia",
        "sub_region": "Southern Asia"
    },
    {
        "label": "Indonesia",
        "value": "ID",
        "icon": "id",
        "iso_3": "IDN",
        "prefix": 62,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Iran, Islamic Republic of",
        "value": "IR",
        "icon": "ir",
        "iso_3": "IRN",
        "prefix": 98,
        "region": "Asia",
        "sub_region": "Southern Asia"
    },
    {
        "label": "Iraq",
        "value": "IQ",
        "icon": "iq",
        "iso_3": "IRQ",
        "prefix": 964,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Ireland",
        "value": "IE",
        "icon": "ie",
        "iso_3": "IRL",
        "prefix": 353,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Isle of Man",
        "value": "IM",
        "icon": "im",
        "iso_3": "IMN",
        "prefix": 44,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Israel",
        "value": "IL",
        "icon": "il",
        "iso_3": "ISR",
        "prefix": 972,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Italy",
        "value": "IT",
        "icon": "it",
        "iso_3": "ITA",
        "prefix": 39,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Jamaica",
        "value": "JM",
        "icon": "jm",
        "iso_3": "JAM",
        "prefix": 1876,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Japan",
        "value": "JP",
        "icon": "jp",
        "iso_3": "JPN",
        "prefix": 81,
        "region": "Asia",
        "sub_region": "Eastern Asia"
    },
    {
        "label": "Jersey",
        "value": "JE",
        "icon": "je",
        "iso_3": "JEY",
        "prefix": 44,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Jordan",
        "value": "JO",
        "icon": "jo",
        "iso_3": "JOR",
        "prefix": 862,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Kazakhstan",
        "value": "KZ",
        "icon": "kz",
        "iso_3": "KAZ",
        "prefix": 7,
        "region": "Asia",
        "sub_region": "Central Asia"
    },
    {
        "label": "Kenya",
        "value": "KE",
        "icon": "ke",
        "iso_3": "KEN",
        "prefix": 254,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Kiribati",
        "value": "KI",
        "icon": "ki",
        "iso_3": "KIR",
        "prefix": 686,
        "region": "Oceania",
        "sub_region": "Micronesia"
    },
    {
        "label": "Korea, Democratic People's Republic of",
        "value": "KP",
        "icon": "kp",
        "iso_3": "PRK",
        "prefix": 850,
        "region": "Asia",
        "sub_region": "Eastern Asia"
    },
    {
        "label": "Korea, Republic of",
        "value": "KR",
        "icon": "kr",
        "iso_3": "KOR",
        "prefix": 82,
        "region": "Asia",
        "sub_region": "Eastern Asia"
    },
    {
        "label": "Kuwait",
        "value": "KW",
        "icon": "kw",
        "iso_3": "KWT",
        "prefix": 965,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Kyrgyzstan",
        "value": "KG",
        "icon": "kg",
        "iso_3": "KGZ",
        "prefix": 996,
        "region": "Asia",
        "sub_region": "Central Asia"
    },
    {
        "label": "Lao People's Democratic Republic",
        "value": "LA",
        "icon": "la",
        "iso_3": "LAO",
        "prefix": 856,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Latvia",
        "value": "LV",
        "icon": "lv",
        "iso_3": "LVA",
        "prefix": 371,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Lebanon",
        "value": "LB",
        "icon": "lb",
        "iso_3": "LBN",
        "prefix": 961,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Lesotho",
        "value": "LS",
        "icon": "ls",
        "iso_3": "LSO",
        "prefix": 266,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Liberia",
        "value": "LR",
        "icon": "lr",
        "iso_3": "LBR",
        "prefix": 231,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Libya",
        "value": "LY",
        "icon": "ly",
        "iso_3": "LBY",
        "prefix": 218,
        "region": "Africa",
        "sub_region": "Northern Africa"
    },
    {
        "label": "Liechtenstein",
        "value": "LI",
        "icon": "li",
        "iso_3": "LIE",
        "prefix": 423,
        "region": "Europe",
        "sub_region": "Western Europe"
    },
    {
        "label": "Lithuania",
        "value": "LT",
        "icon": "lt",
        "iso_3": "LTU",
        "prefix": 370,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Luxembourg",
        "value": "LU",
        "icon": "lu",
        "iso_3": "LUX",
        "prefix": 352,
        "region": "Europe",
        "sub_region": "Western Europe"
    },
    {
        "label": "Macao",
        "value": "MO",
        "icon": "mo",
        "iso_3": "MAC",
        "prefix": 853,
        "region": "Asia",
        "sub_region": "Eastern Asia"
    },
    {
        "label": "Madagascar",
        "value": "MG",
        "icon": "mg",
        "iso_3": "MDG",
        "prefix": 261,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Malawi",
        "value": "MW",
        "icon": "mw",
        "iso_3": "MWI",
        "prefix": 265,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Malaysia",
        "value": "MY",
        "icon": "my",
        "iso_3": "MYS",
        "prefix": 60,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Maldives",
        "value": "MV",
        "icon": "mv",
        "iso_3": "MDV",
        "prefix": 960,
        "region": "Asia",
        "sub_region": "Southern Asia"
    },
    {
        "label": "Mali",
        "value": "ML",
        "icon": "ml",
        "iso_3": "MLI",
        "prefix": 223,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Malta",
        "value": "MT",
        "icon": "mt",
        "iso_3": "MLT",
        "prefix": 356,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Marshall Islands",
        "value": "MH",
        "icon": "mh",
        "iso_3": "MHL",
        "prefix": 692,
        "region": "Oceania",
        "sub_region": "Micronesia"
    },
    {
        "label": "Martinique",
        "value": "MQ",
        "icon": "mq",
        "iso_3": "MTQ",
        "prefix": 596,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Mauritania",
        "value": "MR",
        "icon": "mr",
        "iso_3": "MRT",
        "prefix": 222,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Mauritius",
        "value": "MU",
        "icon": "mu",
        "iso_3": "MUS",
        "prefix": 230,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Mayotte",
        "value": "YT",
        "icon": "yt",
        "iso_3": "MYT",
        "prefix": 262,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Mexico",
        "value": "MX",
        "icon": "mx",
        "iso_3": "MEX",
        "prefix": 52,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Micronesia, Federated States of",
        "value": "FM",
        "icon": "fm",
        "iso_3": "FSM",
        "prefix": 691,
        "region": "Oceania",
        "sub_region": "Micronesia"
    },
    {
        "label": "Moldova, Republic of",
        "value": "MD",
        "icon": "md",
        "iso_3": "MDA",
        "prefix": 373,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "Monaco",
        "value": "MC",
        "icon": "mc",
        "iso_3": "MCO",
        "prefix": 377,
        "region": "Europe",
        "sub_region": "Western Europe"
    },
    {
        "label": "Mongolia",
        "value": "MN",
        "icon": "mn",
        "iso_3": "MNG",
        "prefix": 976,
        "region": "Asia",
        "sub_region": "Eastern Asia"
    },
    {
        "label": "Montenegro",
        "value": "ME",
        "icon": "me",
        "iso_3": "MNE",
        "prefix": 382,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Montserrat",
        "value": "MS",
        "icon": "ms",
        "iso_3": "MSR",
        "prefix": 1664,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Morocco",
        "value": "MA",
        "icon": "ma",
        "iso_3": "MAR",
        "prefix": 212,
        "region": "Africa",
        "sub_region": "Northern Africa"
    },
    {
        "label": "Mozambique",
        "value": "MZ",
        "icon": "mz",
        "iso_3": "MOZ",
        "prefix": 258,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Myanmar",
        "value": "MM",
        "icon": "mm",
        "iso_3": "MMR",
        "prefix": 95,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Namibia",
        "value": "NA",
        "icon": "na",
        "iso_3": "NAM",
        "prefix": 264,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Nauru",
        "value": "NR",
        "icon": "nr",
        "iso_3": "NRU",
        "prefix": 674,
        "region": "Oceania",
        "sub_region": "Micronesia"
    },
    {
        "label": "Nepal",
        "value": "NP",
        "icon": "np",
        "iso_3": "NPL",
        "prefix": 977,
        "region": "Asia",
        "sub_region": "Southern Asia"
    },
    {
        "label": "Netherlands, Kingdom of the",
        "value": "NL",
        "icon": "nl",
        "iso_3": "NLD",
        "prefix": 31,
        "region": "Europe",
        "sub_region": "Western Europe"
    },
    {
        "label": "New Caledonia",
        "value": "NC",
        "icon": "nc",
        "iso_3": "NCL",
        "prefix": 687,
        "region": "Oceania",
        "sub_region": "Melanesia"
    },
    {
        "label": "New Zealand",
        "value": "NZ",
        "icon": "nz",
        "iso_3": "NZL",
        "prefix": 64,
        "region": "Oceania",
        "sub_region": "Australia and New Zealand"
    },
    {
        "label": "Nicaragua",
        "value": "NI",
        "icon": "ni",
        "iso_3": "NIC",
        "prefix": 505,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Niger",
        "value": "NE",
        "icon": "ne",
        "iso_3": "NER",
        "prefix": 227,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Nigeria",
        "value": "NG",
        "icon": "ng",
        "iso_3": "NGA",
        "prefix": 234,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Niue",
        "value": "NU",
        "icon": "nu",
        "iso_3": "NIU",
        "prefix": 683,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    {
        "label": "Norfolk Island",
        "value": "NF",
        "icon": "nf",
        "iso_3": "NFK",
        "prefix": 672,
        "region": "Oceania",
        "sub_region": "Australia and New Zealand"
    },
    {
        "label": "North Macedonia",
        "value": "MK",
        "icon": "mk",
        "iso_3": "MKD",
        "prefix": 389,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Northern Mariana Islands",
        "value": "MP",
        "icon": "mp",
        "iso_3": "MNP",
        "prefix": 1670,
        "region": "Oceania",
        "sub_region": "Micronesia"
    },
    {
        "label": "Norway",
        "value": "NO",
        "icon": "no",
        "iso_3": "NOR",
        "prefix": 47,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Oman",
        "value": "OM",
        "icon": "om",
        "iso_3": "OMN",
        "prefix": 968,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Pakistan",
        "value": "PK",
        "icon": "pl",
        "iso_3": "PAK",
        "prefix": 92,
        "region": "Asia",
        "sub_region": "Southern Asia"
    },
    {
        "label": "Palau",
        "value": "PW",
        "icon": "pw",
        "iso_3": "PLW",
        "prefix": 680,
        "region": "Oceania",
        "sub_region": "Micronesia"
    },
    {
        "label": "Palestine, State of",
        "value": "PS",
        "icon": "ps",
        "iso_3": "PSE",
        "prefix": 970,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Panama",
        "value": "PA",
        "icon": "pa",
        "iso_3": "PAN",
        "prefix": 507,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Papua New Guinea",
        "value": "PG",
        "icon": "pg",
        "iso_3": "PNG",
        "prefix": 675,
        "region": "Oceania",
        "sub_region": "Melanesia"
    },
    {
        "label": "Paraguay",
        "value": "PY",
        "icon": "py",
        "iso_3": "PRY",
        "prefix": 595,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Peru",
        "value": "PE",
        "icon": "pe",
        "iso_3": "PER",
        "prefix": 51,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Philippines",
        "value": "PH",
        "icon": "ph",
        "iso_3": "PHL",
        "prefix": 63,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Pitcairn",
        "value": "PN",
        "icon": "pn",
        "iso_3": "PCN",
        "prefix": 64,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    {
        "label": "Poland",
        "value": "PL",
        "icon": "pl",
        "iso_3": "POL",
        "prefix": 48,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "Portugal",
        "value": "PT",
        "icon": "pt",
        "iso_3": "PRT",
        "prefix": 351,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Puerto Rico",
        "value": "PR",
        "icon": "pr",
        "iso_3": "PRI",
        "prefix": 1787,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Qatar",
        "value": "QA",
        "icon": "qa",
        "iso_3": "QAT",
        "prefix": 974,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Réunion",
        "value": "RE",
        "icon": "re",
        "iso_3": "REU",
        "prefix": 262,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Romania",
        "value": "RO",
        "icon": "ro",
        "iso_3": "ROU",
        "prefix": 40,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "Russian Federation",
        "value": "RU",
        "icon": "ru",
        "iso_3": "RUS",
        "prefix": 7,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "Rwanda",
        "value": "RW",
        "icon": "rw",
        "iso_3": "RWA",
        "prefix": 250,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Saint Barthélemy",
        "value": "BL",
        "icon": "bl",
        "iso_3": "BLM",
        "prefix": 590,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Saint Helena, Ascension and Tristan da Cunha",
        "value": "SH",
        "icon": "sh",
        "iso_3": "SHN",
        "prefix": 247,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Saint Kitts and Nevis",
        "value": "KN",
        "icon": "kn",
        "iso_3": "KNA",
        "prefix": 1869,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Saint Lucia",
        "value": "LC",
        "icon": "lc",
        "iso_3": "LCA",
        "prefix": 1758,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Saint Martin (French part)",
        "value": "MF",
        "icon": "mf",
        "iso_3": "MAF",
        "prefix": 590,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Saint Pierre and Miquelon",
        "value": "PM",
        "icon": "pm",
        "iso_3": "SPM",
        "prefix": 508,
        "region": "Americas",
        "sub_region": "Northern America"
    },
    {
        "label": "Saint Vincent and the Grenadines",
        "value": "VC",
        "icon": "vc",
        "iso_3": "VCT",
        "prefix": 1784,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Samoa",
        "value": "WS",
        "icon": "ws",
        "iso_3": "WSM",
        "prefix": 685,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    {
        "label": "San Marino",
        "value": "SM",
        "icon": "sm",
        "iso_3": "SMR",
        "prefix": 378,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Sao Tome and Principe",
        "value": "ST",
        "icon": "st",
        "iso_3": "STP",
        "prefix": 239,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Saudi Arabia",
        "value": "SA",
        "icon": "sa",
        "iso_3": "SAU",
        "prefix": 966,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Senegal",
        "value": "SN",
        "icon": "sn",
        "iso_3": "SEN",
        "prefix": 221,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Serbia",
        "value": "RS",
        "icon": "rs",
        "iso_3": "SRB",
        "prefix": 381,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Seychelles",
        "value": "SC",
        "icon": "sc",
        "iso_3": "SYC",
        "prefix": 248,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Sierra Leone",
        "value": "SL",
        "icon": "sl",
        "iso_3": "SLE",
        "prefix": 232,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Singapore",
        "value": "SG",
        "icon": "sg",
        "iso_3": "SGP",
        "prefix": 65,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Sint Maarten (Dutch part)",
        "value": "SX",
        "icon": "sx",
        "iso_3": "SXM",
        "prefix": 1721,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Slovakia",
        "value": "SK",
        "icon": "sk",
        "iso_3": "SVK",
        "prefix": 421,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "Slovenia",
        "value": "SI",
        "icon": "si",
        "iso_3": "SVN",
        "prefix": 386,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Solomon Islands",
        "value": "SB",
        "icon": "sb",
        "iso_3": "SLB",
        "prefix": 677,
        "region": "Oceania",
        "sub_region": "Melanesia"
    },
    {
        "label": "Somalia",
        "value": "SO",
        "icon": "so",
        "iso_3": "SOM",
        "prefix": 252,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "South Africa",
        "value": "ZA",
        "icon": "za",
        "iso_3": "ZAF",
        "prefix": 27,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "South Georgia and the South Sandwich Islands",
        "value": "GS",
        "icon": "gs",
        "iso_3": "SGS",
        "prefix": 500,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "South Sudan",
        "value": "SS",
        "icon": "ss",
        "iso_3": "SSD",
        "prefix": 211,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Spain",
        "value": "ES",
        "icon": "es",
        "iso_3": "ESP",
        "prefix": 34,
        "region": "Europe",
        "sub_region": "Southern Europe"
    },
    {
        "label": "Sri Lanka",
        "value": "LK",
        "icon": "lk",
        "iso_3": "LKA",
        "prefix": 94,
        "region": "Asia",
        "sub_region": "Southern Asia"
    },
    {
        "label": "Sudan",
        "value": "SD",
        "icon": "sd",
        "iso_3": "SDN",
        "prefix": 249,
        "region": "Africa",
        "sub_region": "Northern Africa"
    },
    {
        "label": "Suriname",
        "value": "SR",
        "icon": "sr",
        "iso_3": "SUR",
        "prefix": 597,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Svalbard and Jan Mayen",
        "value": "SJ",
        "icon": "sj",
        "iso_3": "SJM",
        "prefix": 47,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Sweden",
        "value": "SE",
        "icon": "se",
        "iso_3": "SWE",
        "prefix": 46,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "Switzerland",
        "value": "CH",
        "icon": "ch",
        "iso_3": "CHE",
        "prefix": 41,
        "region": "Europe",
        "sub_region": "Western Europe"
    },
    {
        "label": "Syrian Arab Republic",
        "value": "SY",
        "icon": "sy",
        "iso_3": "SYR",
        "prefix": 963,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Taiwan, Province of China",
        "value": "TW",
        "icon": "tw",
        "iso_3": "TWN",
        "prefix": 886,
        "region": "",
        "sub_region": ""
    },
    {
        "label": "Tajikistan",
        "value": "TJ",
        "icon": "tj",
        "iso_3": "TJK",
        "prefix": 992,
        "region": "Asia",
        "sub_region": "Central Asia"
    },
    {
        "label": "Tanzania, United Republic of",
        "value": "TZ",
        "icon": "tz",
        "iso_3": "TZA",
        "prefix": 255,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Thailand",
        "value": "TH",
        "icon": "th",
        "iso_3": "THA",
        "prefix": 66,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Timor-Leste",
        "value": "TL",
        "icon": "tl",
        "iso_3": "TLS",
        "prefix": 670,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Togo",
        "value": "TG",
        "icon": "tg",
        "iso_3": "TGO",
        "prefix": 288,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Tokelau",
        "value": "TK",
        "icon": "tk",
        "iso_3": "TKL",
        "prefix": 690,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    {
        "label": "Tonga",
        "value": "TO",
        "icon": "to",
        "iso_3": "TON",
        "prefix": 676,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    {
        "label": "Trinidad and Tobago",
        "value": "TT",
        "icon": "tt",
        "iso_3": "TTO",
        "prefix": 1868,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Tunisia",
        "value": "TN",
        "icon": "tn",
        "iso_3": "TUN",
        "prefix": 216,
        "region": "Africa",
        "sub_region": "Northern Africa"
    },
    {
        "label": "Türkiye",
        "value": "TR",
        "icon": "tr",
        "iso_3": "TUR",
        "prefix": 90,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Turkmenistan",
        "value": "TM",
        "icon": "tm",
        "iso_3": "TKM",
        "prefix": 993,
        "region": "Asia",
        "sub_region": "Central Asia"
    },
    {
        "label": "Turks and Caicos Islands",
        "value": "TC",
        "icon": "tc",
        "iso_3": "TCA",
        "prefix": 1649,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Tuvalu",
        "value": "TV",
        "icon": "tv",
        "iso_3": "TUV",
        "prefix": 688,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    {
        "label": "Uganda",
        "value": "UG",
        "icon": "ug",
        "iso_3": "UGA",
        "prefix": 256,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Ukraine",
        "value": "UA",
        "icon": "ua",
        "iso_3": "UKR",
        "prefix": 380,
        "region": "Europe",
        "sub_region": "Eastern Europe"
    },
    {
        "label": "United Arab Emirates",
        "value": "AE",
        "icon": "ae",
        "iso_3": "ARE",
        "prefix": 971,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "United Kingdom of Great Britain and Northern Ireland",
        "value": "GB",
        "icon": "gb",
        "iso_3": "GBR",
        "prefix": 44,
        "region": "Europe",
        "sub_region": "Northern Europe"
    },
    {
        "label": "United States of America",
        "value": "US",
        "icon": "us",
        "iso_3": "USA",
        "prefix": 1,
        "region": "Americas",
        "sub_region": "Northern America"
    },
    {
        "label": "United States Minor Outlying Islands",
        "value": "UM",
        "icon": "um",
        "iso_3": "UMI",
        "prefix": 1340,
        "region": "Oceania",
        "sub_region": "Micronesia"
    },
    {
        "label": "Uruguay",
        "value": "UY",
        "icon": "uy",
        "iso_3": "URY",
        "prefix": 598,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Uzbekistan",
        "value": "UZ",
        "icon": "uz",
        "iso_3": "UZB",
        "prefix": 998,
        "region": "Asia",
        "sub_region": "Central Asia"
    },
    {
        "label": "Vanuatu",
        "value": "VU",
        "icon": "vu",
        "iso_3": "VUT",
        "prefix": 678,
        "region": "Oceania",
        "sub_region": "Melanesia"
    },
    {
        "label": "Venezuela, Bolivarian Republic of",
        "value": "VE",
        "icon": "ve",
        "iso_3": "VEN",
        "prefix": 58,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Viet Nam",
        "value": "VN",
        "icon": "vn",
        "iso_3": "VNM",
        "prefix": 84,
        "region": "Asia",
        "sub_region": "South-eastern Asia"
    },
    {
        "label": "Virgin Islands (British)",
        "value": "VG",
        "icon": "vg",
        "iso_3": "VGB",
        "prefix": 284,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Virgin Islands (U.S.)",
        "value": "VI",
        "icon": "vi",
        "iso_3": "VIR",
        "prefix": 1340,
        "region": "Americas",
        "sub_region": "Latin America and the Caribbean"
    },
    {
        "label": "Wallis and Futuna",
        "value": "WF",
        "icon": "wf",
        "iso_3": "WLF",
        "prefix": 681,
        "region": "Oceania",
        "sub_region": "Polynesia"
    },
    {
        "label": "Western Sahara",
        "value": "EH",
        "icon": "eh",
        "iso_3": "ESH",
        "prefix": 212,
        "region": "Africa",
        "sub_region": "Northern Africa"
    },
    {
        "label": "Yemen",
        "value": "YE",
        "icon": "ye",
        "iso_3": "YEM",
        "prefix": 967,
        "region": "Asia",
        "sub_region": "Western Asia"
    },
    {
        "label": "Zambia",
        "value": "ZM",
        "icon": "zm",
        "iso_3": "ZMB",
        "prefix": 260,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    },
    {
        "label": "Zimbabwe",
        "value": "ZW",
        "icon": "zw",
        "iso_3": "ZWE",
        "prefix": 263,
        "region": "Africa",
        "sub_region": "Sub-Saharan Africa"
    }
]


export const getNodeEnv = (): string =>
    NODE_ENV ;